import type { AxiosError } from "axios";

import { axios } from "~/core/axios";
import type {
  BackendApiErrorResponse,
  BackendApiResponse,
} from "~/core/types/backend-api-response.type";

import type {
  GetMembershipByEmail,
  GetUserAndOrgDataById,
  OrgTeamMember,
} from "./types";

export const getOrgTeamMembers = async (orgId: string) => {
  try {
    const { data } = await axios.get<BackendApiResponse<OrgTeamMember[]>>(
      `/organization/${orgId}/members`,
    );

    return data.data;
  } catch (error) {
    const err = error as AxiosError<BackendApiErrorResponse>;
    throw new Error(err.response?.data.message ?? "Something went wrong!");
  }
};

export const getUserAndOrgDataById = async (
  org_id: string,
  user_id: string,
  accessToken: string,
) => {
  try {
    const { data } = await axios.get<BackendApiResponse<GetUserAndOrgDataById>>(
      `/organization/${org_id}/user/${user_id}`,
    );

    return data.data;
  } catch (error) {
    const err = error as AxiosError<BackendApiErrorResponse>;
    console.log(err.response?.data);
    return null;
  }
};

export const getMembershipByEmail = async (
  org_id: string,
  email: string,
  accessToken: string,
) => {
  try {
    const { data } = await axios.get<BackendApiResponse<GetMembershipByEmail>>(
      `/membership/${org_id}/membership/${email}`,
    );

    return data.data;
  } catch (error) {
    const err = error as AxiosError<BackendApiErrorResponse>;
    console.log(err.response?.data);
    return null;
  }
};

export const updateMembershipById = async (
  membership_id: number,
  membership: any,
  accessToken: string,
) => {
  try {
    const { data } = await axios.put<BackendApiResponse>(
      `/membership/${membership_id}`,
      membership,
    );

    return data.data;
  } catch (error) {
    const err = error as AxiosError<BackendApiErrorResponse>;
    console.log(err.response?.data);
    return null;
  }
};
